import React from "react";
import PropTypes from "prop-types";
import { SubmittingButton, CloseIcon } from "../../uikit";
import { ModalDialog, inEmbedMode } from "../../../odc-ui";
import numeral from "numeral";
import { capitalizeFirstLetter } from "../../../utilities/general_utils";

const ConfirmationModal = ({
  authenticated,
  hasExistingAccount,
  selectedProduct,
  cardBrand,
  firstName,
  lastName,
  email,
  phone,
  selectedDateOfBirthMonthOption,
  selectedDateOfBirthDayOption,
  onSubmitClick,
  submittingForm,
  theme,
  onCloseClick,
}) => {
  return (
    <ModalDialog modalDialogClassName="add-funds-dialog" darkMode>
      <div>
        <a
          onClick={(e) => {
            e.preventDefault();
            onCloseClick(false);
          }}
        >
          <CloseIcon className="close-button" />
        </a>
        <div className="main-caption">You&apos;re adding funds</div>
        <div className="details">
          <div className="detail">
            <span className="label">Amount: </span>
            <span className="value">
              {numeral(selectedProduct.price).format("$0,0.00")}
            </span>
          </div>
          <div className="detail">
            <span className="label">From card: </span>
            <span className="value">
              {cardBrand && capitalizeFirstLetter(cardBrand)}
            </span>
          </div>
          <div className="label note detail">
            <div className="first-col">Note:</div>
            <div>
              CAD $1 = 1 Healthcoin<sup>®</sup>
              <br />
              Access{" "}
              <a className="light-link underline" href="/terms_and_conditions">
                Terms & Conditions
              </a>
            </div>
          </div>
          {!authenticated && (
            <>
              {
                <div className="detail">
                  <span className="label">Existing Healthcoin® User: </span>
                  <span className="value">
                    {hasExistingAccount ? "Yes" : "No"}
                  </span>
                </div>
              }
              {!hasExistingAccount && (
                <div className="detail">
                  <span className="label">Name: </span>
                  <span className="value">
                    {firstName} {lastName}
                  </span>
                </div>
              )}
              <div className="detail">
                <span className="label">Email: </span>
                <span className="value">{email}</span>
              </div>
              {!hasExistingAccount && (
                <div className="detail">
                  <span className="label">Phone: </span>
                  <span className="value">{phone}</span>
                </div>
              )}
              {!hasExistingAccount && (
                <div className="detail">
                  <span className="label">Birthday: </span>
                  <span className="value">
                    {selectedDateOfBirthMonthOption.label}{" "}
                    {selectedDateOfBirthDayOption.label}
                  </span>
                </div>
              )}
            </>
          )}
        </div>
        <div className="actions">
          <SubmittingButton
            type={
              inEmbedMode()
                ? "embed"
                : theme === "paige"
                ? "primary-paige"
                : "primary"
            }
            fullWidth
            onClick={onSubmitClick}
            submitting={submittingForm}
            submittingText="Submitting..."
            text="Confirm"
            textTransform="none"
          />
        </div>
      </div>
    </ModalDialog>
  );
};

ConfirmationModal.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  hasExistingAccount: PropTypes.bool.isRequired,
  selectedSubscriptionPlan: PropTypes.object.isRequired,
  selectedSubscriptionPlanVariation: PropTypes.object.isRequired,
  selectedProduct: PropTypes.object.isRequired,
  cardBrand: PropTypes.string,
  selectedSquareCard: PropTypes.object,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
  selectedDateOfBirthMonthOption: PropTypes.object.isRequired,
  selectedDateOfBirthDayOption: PropTypes.object.isRequired,
  onSubmitClick: PropTypes.func.isRequired,
  submittingForm: PropTypes.bool.isRequired,
  theme: PropTypes.string.isRequired,
  onCloseClick: PropTypes.func.isRequired,
};

export default ConfirmationModal;
